// Simple boot timing logger used to track startup milestones.
export function logBootEvent(name) {
  try {
    const entry = { name, ts: new Date().toISOString() };
    if (typeof window !== 'undefined') {
      window.__BOOT_TIMINGS = window.__BOOT_TIMINGS || [];
      window.__BOOT_TIMINGS.push(entry);
    }
    // Keep a visible console trace for smoke-tests

    console.info(`[BOOT] ${entry.name} @ ${entry.ts}`);
  } catch (e) {
    // swallow
    void e;
  }
}

export function getBootTimings() {
  return (typeof window !== 'undefined' && window.__BOOT_TIMINGS) || [];
}
